import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/redux/store'
import { useAppDispatch } from '../../store/redux/hooks'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Box, IconButton, Typography, styled } from '@mui/material'
import { getSelectedDate, monthPickerActions } from '../../store/redux/reducers/monthPickerSlice'
import DateFormat from '../../store/types/enums/DateFormat'
import { t } from 'i18next'

const StyledMonthPicker = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
}))

const StyledMonthAndYearContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 65,
}))

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: 28,
  height: 28,
  '& svg': {
    color: 'text.mediumEmphasis',
  },
  '&:hover': {
    svg: {
      color: 'text.highEmphasis',
    },
  },
}))

const YearPicker = () => {
  const selectedDate = dayjs(useSelector((state: RootState) => getSelectedDate(state)))
  const dispatch = useAppDispatch()

  return (
    <StyledMonthPicker>
      <StyledIconButton
        aria-label={t('page.component.yearPicker.arrowLeft')}
        size="small"
        onClick={() => dispatch(monthPickerActions.decreaseYear())}
      >
        <ChevronLeft />
      </StyledIconButton>

      <StyledMonthAndYearContainer>
        <Typography variant="body2" fontWeight={700} fontSize={16} sx={{ color: 'text.highEmphasis' }}>
          {selectedDate.format(DateFormat.Year)}
        </Typography>
      </StyledMonthAndYearContainer>

      <StyledIconButton
        aria-label={t('page.component.yearPicker.arrowRight')}
        size="small"
        onClick={() => dispatch(monthPickerActions.increaseYear())}
      >
        <ChevronRight />
      </StyledIconButton>
    </StyledMonthPicker>
  )
}

export default YearPicker
